module.exports = __webpack_public_path__ + "img/banner05_info_S_3.96c9420c.png";